module.exports = __webpack_public_path__ + "static/media/image 9.71f342f0.png";